const currentYear = new Date().getFullYear();

const locale = {
    code: "bn",
    label: "বাংলা",
    NAV_BAR: {
        home: "হোম",
        homeId: "home",
        aboutus: "আমাদের সম্পর্কে",
        aboutId: "aboutus",
        faq: "প্রশ্নাবলী",
        faqId: "faq-section",
        contact: "যোগাযোগ",
        contactId: "contact-section",
        button: "আগাম অ্যাক্সেস পান",
    },

    HERO: {
        heroHeading: "আপনার মেনু, তাত্ক্ষণিকভাবে অ্যাক্সেসযোগ্য",
        heroParagraph:
            "একটি QR কোড দিয়ে আপনার মেনু তৈরি, আপডেট এবং শেয়ার করুন — কোনো ঝামেলা নেই, পুনরায় মুদ্রণের প্রয়োজন নেই।",
        button: "আগাম অ্যাক্সেস পান",
        downloadText: "ডাউনলোড করুন",
        appStore: "App Store",
        getItOn: "GET IT ON",
        googlePlay: "Google Play",
    },

    SERVICES: {
        heading: "আমাদের সেবা",
        cards: [
            {
                title: "মেনু তৈরি করুন এবং আপলোড করুন",
                description:
                    "কেবল কয়েক ক্লিকে সহজেই আপনার মেনু তৈরি এবং আপলোড করুন! আইটেম যোগ করুন, দাম সেট করুন, এবং বিস্তারিত আপডেট করুন কোনও প্রযুক্তিগত দক্ষতা ছাড়াই।",
            },
            {
                title: "মেনু আপডেট করুন",
                description:
                    "যেকোনো সময়, যেকোনো জায়গায় আপনার মেনু রিয়েল-টাইমে আপডেট করুন! দাম পরিবর্তন করুন, নতুন খাবার যোগ করুন বা অনুপলব্ধ আইটেম অবিলম্বে আর্কাইভ করুন।",
            },
            {
                title: "উত্পন্ন করুন এবং শেয়ার করুন",
                description:
                    "একটি অনন্য QR কোড দ্রুত তৈরি করুন! এটি টেবিল, পোষ্টার বা অনলাইনে শেয়ার করুন যাতে গ্রাহকরা স্ক্যান করে আপনার সর্বশেষ মেনু দেখতে পারে।",
            },
        ],
    },

    FEATURES: {
        heading: "আমাদের অসাধারণ বৈশিষ্ট্যগুলি অন্বেষণ করুন",
        lists: [
            {
                title: "মেনু পরিচালনা করুন",
                description:
                    "যেকোনো সময় আপনার মেনু পরিচালনা করুন! সহজেই আইটেম যোগ, সম্পাদনা বা মুছুন এবং আপনার পণ্য আপ টু ডেট রাখুন।",
            },
            {
                title: "তথ্য এবং রিপোর্ট",
                description:
                    "রিয়েল-টাইম রিপোর্টের মাধ্যমে মূল্যবান তথ্য পান! মেনু ভিউ, QR কোড স্ক্যান এবং গ্রাহক ইন্টারঅ্যাকশন ট্র্যাক করুন।",
            },
            {
                title: "QR কোড শেয়ার করুন",
                description:
                    "একটি অনন্য QR কোড দিয়ে আপনার মেনু শেয়ার করুন! এটি টেবিল, পোষ্টার বা অনলাইনে প্রদর্শন করুন যাতে গ্রাহকরা তা দ্রুত স্ক্যান করতে পারে।",
            },
            {
                title: "গ্রাহক মন্তব্য",
                description:
                    "প্রকৃত গ্রাহক প্রতিক্রিয়া এবং রেটিং প্রদর্শন করুন! বিশ্বাস গড়ে তুলুন, আপনার মেনু উন্নত করুন, এবং ডাইনিং অভিজ্ঞতা উন্নত করুন।",
            },
            {
                title: "অফার এবং ডিসকাউন্ট",
                description:
                    "বিশেষ অফার এবং ডিসকাউন্টের মাধ্যমে বিক্রয় বৃদ্ধি করুন! সীমিত সময়ের প্রচার এবং একচেটিয়া ডিসকাউন্টগুলি হাইলাইট করুন।",
            },
        ],
    },

    ABOUT: {
        heading: "My QR Menu সম্পর্কে",
        headingPara: "রিয়েল-টাইম আপডেট সহ আপনার রেস্টুরেন্ট মেনু পরিচালনাকে সহজ করুন।",
        highlightHeading: "আপনার যা প্রয়োজন তা দ্রুত এবং সহজেই অ্যাক্সেস করুন",
        highlightPara: "আপনার সমস্ত মেনু বৈশিষ্ট্য — শুধুমাত্র একটি ট্যাপে।",
        cards: {
            left: {
                heading: ["সহজে উপাদান যোগ করুন", "আপনার QR মেনুতে"],
                alt: "উপাদান যোগ করুন",
            },
            right: {
                heading: ["সহজেই আপনার মেনু", "ড্যাশবোর্ডে প্রবেশ করুন"],
                alt: "মেনু ড্যাশবোর্ড",
            },
        },
    },

    FAQ: {
        heading: "আপনার প্রশ্ন রয়েছে। আমাদের উত্তর রয়েছে।",
        subheading: "প্রোডাক্ট সম্পর্কে আপনার যা জানা দরকার।",
        items: [
            {
                question: "My QRMenu কী?",
                answer:
                    "My QRMenu একটি ডিজিটাল মেনু প্ল্যাটফর্ম যা রেস্টুরেন্টগুলোকে QR কোড ব্যবহার করে তাদের মেনু দ্রুত তৈরির, আপডেটের ও শেয়ার করার সুযোগ দেয়।",
            },
            {
                question: "তৈরির পর কি আমি আমার মেনু আপডেট করতে পারি?",
                answer:
                    "হ্যাঁ, আপনি যেকোনো সময় আপনার মেনু আপডেট করতে পারেন এবং গ্রাহকরা QR কোড স্ক্যান করলে তা অবিলম্বে দেখতে পারবেন।",
            },
            {
                question: "My QRMenu কীভাবে কাজ করে?",
                answer:
                    "আপনি একটি মেনু তৈরি করেন, একটি QR কোড তৈরি করেন, এবং গ্রাহকরা স্ক্যান করে আপনার মেনুর সর্বশেষ সংস্করণ দেখেন।",
            },
            {
                question: "আমি কীভাবে আমার QR কোড শেয়ার করব?",
                answer:
                    "আপনি QR কোডটি ডিজিটালি শেয়ার করতে পারেন বা আপনার রেস্টুরেন্টে প্রদর্শনের জন্য প্রিন্ট করতে পারেন।",
            },
            {
                question: "My QRMenu কি মোবাইল বন্ধুত্বপূর্ণ?",
                answer:
                    "হ্যাঁ, My QRMenu সকল ডিভাইসের জন্য অপটিমাইজড, মোবাইল ফোন এবং ট্যাবলেট সহ।",
            },
            {
                question: "আমি কি গ্রাহক প্রতিক্রিয়া সংগ্রহ করতে পারি?",
                answer:
                    "হ্যাঁ, আপনি গ্রাহক প্রতিক্রিয়া সক্রিয় করতে পারেন এবং আপনার প্রস্তাব উন্নত করতে প্রতিক্রিয়া ব্যবহার করতে পারেন।",
            },
        ],
    },

    CONTACT: {
        heading: "যোগাযোগ করুন",
        subheading: "আমাদের বন্ধুবান্ধব দল আপনার কথা শুনতে অপেক্ষা করছে।",
        firstName: "প্রথম নাম",
        lastName: "শেষ নাম",
        email: "ইমেইল",
        message: "বার্তা",
        firstNamePlaceholder: "প্রথম নাম",
        lastNamePlaceholder: "শেষ নাম",
        emailPlaceholder: "আপনি@কোম্পানি.com",
        messagePlaceholder: "আপনার বার্তা লিখুন...",
        privacyConsent: "আপনি আমাদের সাথে একমত",
        privacyPolicy: "গোপনীয়তা নীতি",
        submitButton: "বার্তা পাঠান",
        toast: {
            requiredConsent: "আপনাকে গোপনীয়তা নীতিতে একমত হতে হবে।",
            submitting: "বার্তা পাঠানো হচ্ছে...",
            success: "বার্তা সফলভাবে পাঠানো হয়েছে!",
            fail: "বার্তা পাঠাতে ব্যর্থ হয়েছে। অনুগ্রহ করে আবার চেষ্টা করুন।",
            error: "একটি ত্রুটি ঘটেছে। অনুগ্রহ করে আপনার সংযোগ পরীক্ষা করুন।",
        },
    },

    HELP_PAGE: {
        title: "সাহায্য কেন্দ্র",
        description: "আপনার যদি কোনও প্রশ্ন থাকে বা সহায়তা প্রয়োজন হয়, অনুগ্রহ করে আমাদের সাথে যোগাযোগ করুন: ",
        contactEmail: "contact@myqrmenu.co",
        faqPrompt: "অথবা নিচের সর্বাধিক জিজ্ঞাসিত প্রশ্নগুলি দেখুন, আপনি যা খুঁজছেন তা পেতে পারেন।",
    },

    FOOTER: {
        footerHeading: "সুগম ডিজিটাল মেনু, সহজীকৃত!",
        footerButton: "ওয়েটলিস্টে যোগ দিন",
        footerConnect: "আমাদের সাথে সংযুক্ত হন",
        footerTerms: "শর্তাবলি ও চুক্তি",
        footerHelp: "সাহায্য কেন্দ্র",
        footerPrivacy: "গোপনীয়তা নীতি",
        footerCopyright: `©${currentYear} সর্বস্বত্ব সংরক্ষিত।`,
    },

    PRIVACY_POLICY: {
        title: "গোপনীয়তা নীতি",
        lastUpdated: "آخر تحديث: 22 مايو 2025",
        content: `
            <article class="mb-12">
                <p class="mb-6 leading-relaxed">
                এই গোপনীয়তা নীতি আমাদের নীতি এবং পদ্ধতির বর্ণনা দেয় যখন আপনি পরিষেবাটি ব্যবহার করেন।
                </p>
                <p class="mb-6 leading-relaxed">
                আমরা আপনার ব্যক্তিগত ডেটা পরিষেবা প্রদান এবং উন্নত করতে ব্যবহার করি। পরিষেবাটি ব্যবহার করে, আপনি এই গোপনীয়তা নীতি অনুসারে তথ্য সংগ্রহ এবং ব্যবহারে সম্মত হন।
                </p>
            </article>

            <section class="mb-12">
                <header class="mb-6">
                <h2 class="text-2xl font-semibold">ব্যাখ্যা এবং সংজ্ঞা</h2>
                </header>
                <article class="mb-8">
                <h3 class="text-xl font-semibold mb-2">ব্যাখ্যা</h3>
                <p class="mb-6 leading-relaxed">
                    যে শব্দগুলির প্রথম অক্ষর বড় হাতের সেগুলি নিম্নলিখিত শর্তাবলীর অধীনে সংজ্ঞায়িত করা হয়েছে।
                </p>
                </article>

                <article>
                <h3 class="text-xl font-semibold mb-4">সংজ্ঞা</h3>
                <ul class="list-disc list-inside mb-6 space-y-3 text-gray-800">
                    <li><strong>অ্যাকাউন্ট</strong> মানে আমাদের পরিষেবা অ্যাক্সেস করার জন্য আপনার জন্য তৈরি একটি অনন্য অ্যাকাউন্ট।</li>
                    <li><strong>কোম্পানি</strong> My QR Menu, লন্ডন, যুক্তরাজ্যকে নির্দেশ করে।</li>
                    <li><strong>ব্যক্তিগত ডেটা</strong> এমন কোনও তথ্য যা কোনও চিহ্নিত বা শনাক্তযোগ্য ব্যক্তির সাথে সম্পর্কিত।</li>
                    <li><strong>আপনি</strong> মানে সেই ব্যক্তি যিনি পরিষেবাটি অ্যাক্সেস করছেন বা ব্যবহার করছেন।</li>
                </ul>
                </article>
            </section>

            <section class="mb-12">
                <h2 class="text-2xl font-semibold mb-6">যোগাযোগ করুন</h2>
                <p>
                এই গোপনীয়তা নীতি সম্পর্কে আপনার যদি কোনও প্রশ্ন থাকে তবে আপনি আমাদের সাথে যোগাযোগ করতে পারেন:
                </p>
                <ul class="list-disc list-inside mt-2">
                <li>ইমেলের মাধ্যমে: <a href="mailto:hello@myqrmenu.co" class="text-gray-800 underline">hello@myqrmenu.co</a></li>
                </ul>
            </section>
        `
    },

    TERMS_AND_CONDITIONS: {
        title: "শর্তাবলী ও চুক্তি",
        lastUpdated: "শেষ আপডেট: ২২ মে, ২০২৫",
        content: `
            <p class="leading-relaxed mb-6">
            আমাদের অ্যাপ বা ওয়েবসাইট ব্যবহার করার আগে দয়া করে এই শর্তাবলী মনোযোগ সহকারে পড়ুন।
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">১. ব্যাখ্যা এবং সংজ্ঞা</h2>
            <h3 class="text-xl font-semibold mt-6 mb-2">ব্যাখ্যা</h3>
            <p class="leading-relaxed mb-4">
            যে শব্দগুলির প্রথম অক্ষর বড় হাতের সেগুলি নিম্নলিখিত শর্তাবলীর অধীনে সংজ্ঞায়িত করা হয়েছে।
            </p>
            <h3 class="text-xl font-semibold mt-6 mb-2">সংজ্ঞা</h3>
            <ul class="list-disc list-inside mb-6 leading-relaxed text-gray-800">
            <li><strong>অ্যাপ্লিকেশন</strong> মানে My QR Menu দ্বারা প্রদান করা সফটওয়্যার।</li>
            <li><strong>কোম্পানি</strong> My QR Menu, লন্ডন, যুক্তরাজ্যকে নির্দেশ করে।</li>
            <li><strong>পরিষেবা</strong> অ্যাপ্লিকেশন এবং ওয়েবসাইটকে নির্দেশ করে।</li>
            <li><strong>আপনি</strong> মানে সেই ব্যক্তি বা ব্যবসা যারা পরিষেবাটি ব্যবহার করছেন।</li>
            </ul>

            <h2 class="text-2xl font-semibold mt-10 mb-4">২. স্বীকৃতি</h2>
            <p class="leading-relaxed mb-6">
            পরিষেবাটি ব্যবহার করে, আপনি এই শর্তাবলী দ্বারা বাধ্য হতে সম্মত হন। আপনি যদি কোনও অংশের সাথে দ্বিমত পোষণ করেন তবে আপনি পরিষেবাটি অ্যাক্সেস করতে পারবেন না।
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">৩. অন্যান্য ওয়েবসাইটের লিঙ্ক</h2>
            <p class="leading-relaxed mb-6">
            আমাদের পরিষেবাতে তৃতীয় পক্ষের ওয়েবসাইটের লিঙ্ক থাকতে পারে। আমরা তাদের বিষয়বস্তু বা অনুশীলনের জন্য কোনও নিয়ন্ত্রণ বা দায়িত্ব গ্রহণ করি না।
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">৪. অবসান</h2>
            <p class="leading-relaxed mb-6">
            আমরা কোনো কারণ ছাড়াই অবিলম্বে আপনার পরিষেবা অ্যাক্সেস বন্ধ বা স্থগিত করার অধিকার সংরক্ষণ করি।
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">৫. দায়ের সীমাবদ্ধতা</h2>
            <p class="leading-relaxed mb-6">
            আইন দ্বারা অনুমোদিত সর্বোচ্চ সীমা পর্যন্ত, পরিষেবাটি ব্যবহারের ফলে উদ্ভূত কোনও ক্ষতির জন্য কোম্পানি দায়বদ্ধ থাকবে না।
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">৬. "যেমন আছে" এবং "যেমন উপলব্ধ" দাবিত্যাগ</h2>
            <p class="leading-relaxed mb-6">
            পরিষেবাটি আপনাকে "যেমন আছে" এবং "যেমন উপলব্ধ" ভিত্তিতে সরবরাহ করা হয়। আমরা গ্যারান্টি দিই না যে এটি ত্রুটিমুক্ত বা নিরবচ্ছিন্ন হবে।
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">৭. পরিচালনা আইন</h2>
            <p class="leading-relaxed mb-6">
            এই শর্তাবলী যুক্তরাজ্যের আইন দ্বারা পরিচালিত হবে।
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">৮. বিরোধ নিষ্পত্তি</h2>
            <p class="leading-relaxed mb-6">
            আপনার যদি আমাদের সাথে কোনও বিরোধ থাকে তবে আপনি আইনি ব্যবস্থা নেওয়ার আগে এটি অনানুষ্ঠানিকভাবে সমাধান করার চেষ্টা করতে সম্মত হন।
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">৯. ইউরোপীয় ইউনিয়ন (EU) ব্যবহারকারীদের জন্য</h2>
            <p class="leading-relaxed mb-6">
            আপনি যদি ইইউ-এর একজন ভোক্তা হন তবে আপনি আপনার বসবাসের দেশের আইনের বাধ্যতামূলক বিধানের সুরক্ষার অধিকারী।
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">১০. মার্কিন যুক্তরাষ্ট্র আইনি সম্মতি</h2>
            <p class="leading-relaxed mb-6">
            আপনি প্রতিনিধিত্ব করছেন এবং ওয়ারেন্টি দিচ্ছেন যে আপনি মার্কিন সরকারের নিষেধাজ্ঞার অধীনস্থ কোনো দেশে অবস্থিত নন।
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">১১. বিচ্ছিন্নতা এবং মওকুফ</h2>
            <h3 class="text-xl font-semibold mt-6 mb-2">বিচ্ছিন্নতা</h3>
            <p class="leading-relaxed mb-4">
            যদি এই শর্তাবলীর কোনো বিধান অপ্রয়োগযোগ্য বলে প্রমাণিত হয়, তবে অবশিষ্ট বিধানগুলি কার্যকর থাকবে।
            </p>
            <h3 class="text-xl font-semibold mt-6 mb-2">মওকুফ</h3>
            <p class="leading-relaxed mb-6">
            কোনো বিধান কার্যকর করতে ব্যর্থ হওয়া সেই অধিকার মওকুফ বলে গণ্য হবে না।
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">১২. অনুবাদ ব্যাখ্যা</h2>
            <p class="leading-relaxed mb-6">
            এই শর্তাবলী অনুবাদ করা হয়ে থাকতে পারে। বিরোধের ক্ষেত্রে ইংরেজি সংস্করণ প্রাধান্য পাবে।
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">১৩. এই শর্তাবলীর পরিবর্তন</h2>
            <p class="leading-relaxed mb-6">
            আমরা যেকোনো সময় এই শর্তাবলী আপডেট করতে পারি। আমরা আমাদের ওয়েবসাইটে একটি নোটিশ পোস্ট করে আপনাকে অবহিত করব।
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">১৪. যোগাযোগ করুন</h2>
            <p class="leading-relaxed mb-2">এই শর্তাবলী সম্পর্কে আপনার প্রশ্ন থাকলে, আপনি আমাদের সাথে যোগাযোগ করতে পারেন:</p>
            <ul class="list-disc list-inside text-gray-800">
            <li>ইমেলের মাধ্যমে: <a href="mailto:hello@myqrmenu.co" class="text-blue-600 underline">hello@myqrmenu.co</a></li>
            </ul>
        `
    }
};

export default locale;
